import { supabaseClient } from "supabase";

export const queryTags = async () => {
  const { data, error } = await supabaseClient
    .from("tags")
    .select("id,tag,tag_pt");
  if (error) {
    throw error;
  }
  return data;
};
